module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-solid-900.woff2";